// This file is generated by scripts/sync-flux-version.mjs.
// Do not edit by hand.

export const FLUX_VERSION = "0.1.7";
export const FLUX_REPO_URL = "https://github.com/cbassuarez/flux";
export const FLUX_REPO_PERMALINK =
  "https://github.com/cbassuarez/flux/tree/v0.1.7";
